import { render, staticRenderFns } from "./chatbotSettings.vue?vue&type=template&id=5ac075c8&scoped=true&"
import script from "./chatbotSettings.vue?vue&type=script&lang=js&"
export * from "./chatbotSettings.vue?vue&type=script&lang=js&"
import style0 from "./chatbotSettings.vue?vue&type=style&index=0&id=5ac075c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac075c8",
  null
  
)

export default component.exports